import config from '@config';
import { color } from 'framer-motion';
import merge from 'lodash/merge';

const fontFamily = 'FedraSansStd-medium';

const commonLangStyle = ({ lang, ...props }) => {
  const isIndian = config.indianLang.indexOf(lang) > -1;
  const styleObj = {
    title: {
      fontSize: { base: '40px', md: '54px' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      lineHeight: { base: 'auto', md: 'auto' },
      fontStyle: 'italic',
      color: '#EC1C2D',
    },
    titleSubtext: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      fontSize: { base: '40px', md: '54px' },
      lineHeight: { base: 'auto', md: 'auto' },
    },
    title_1: {
      fontSize: { base: '22px', md: '32px' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      lineHeight: { base: '130%', md: '130%' },
    },
    text3: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      fontSize: { base: '2rem', md: '48px' },
      lineHeight: { base: '28.8px', md: '43.2px' },
      color: '#fff',
    },
    item: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { base: '1rem', md: '20px' },
      lineHeight: { base: '20.8px', md: '26px' },
      color: '#FFFFFFB2',
      textAlign: { base: 'center', md: 'left' },
    },
    desc: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { base: '1rem', md: '24px' },
      fontWeight: '400',
      lineHeight: { base: '20px', md: '28.8px' },
      color: '#FFFFFFB2',
    },
    closedMessage: {
      fontSize: { lg: '80px', md: '60px', base: '42px' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
    },
    bottomText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { md: '18px', base: '20px' },
      lineHeight: { base: '20px', md: '22px' },
      color: '#fff',
    },
    item1: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { base: '12px' },
      lineHeight: { base: 'auto' },
      color: '#FFFFFF99',
    },
    item2: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { base: '18px' },
      fontWeight: '500',
      textAlign: { base: 'left' },
      lineHeight: { base: '120%' },
    },
    item3: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontWeight: '400',
      fontSize: { base: '14px' },
      lineHeight: { base: '140%' },
      color: '#FFFFFF99',
    },
    item4: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontWeight: '400',
      fontSize: { base: '14px' },
      lineHeight: { base: 'auto' },
      color: '#FFFFFF',
      letterSpacing: '-1px',
      padding: '7px 12px 4px 18px',
    },
    item5: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontWeight: '500',
      fontSize: { base: '14px' },
      lineHeight: { base: '140%' },
      color: '#AAAAAA',
    },
    item6: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { base: '22px' },
      lineHeight: { base: '112%' },
      color: '#FFFFFF',
    },
    searchbuttonlink: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontWeight: '400',
      fontSize: { base: '14px' },
      lineHeight: { base: 'auto' },
      color: '#FFFFFF',
      letterSpacing: '-1px',
      padding: '9px 12px 8px 18px',
    },
    featureditem1: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { base: '14px' },
      fontWeight: '500',
      lineHeight: { base: 'auto' },
      color: '#EC1C2D',
    },
    featureditem2: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { base: '18px' },
      fontWeight: '500',
      textAlign: { base: 'left' },
      lineHeight: { base: '120%' },
    },
    featureditem3: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontWeight: '400',
      fontSize: { base: '14px' },
      lineHeight: { base: '140%' },
      color: '#FFFFFF99',
    },
    featureditem4: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontWeight: '400',
      fontSize: { base: '14px' },
      lineHeight: { base: 'auto' },
      color: '#FFFFFF',
      letterSpacing: '-1px',
      padding: '7px 12px 4px 18px',
    },
    populararticleitem1: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { base: '12px' },
      fontWeight: '500',
      lineHeight: { base: 'auto' },
      color: '#FFFFFF99',
    },
    populararticleitem2: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { base: '20px' },
      fontWeight: '500',
      textAlign: { base: 'left' },
      lineHeight: { base: '111%' },
    },
    populararticleitem3: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontWeight: '400',
      fontSize: { base: '14px' },
      lineHeight: { base: '140%' },
      color: '#FFFFFF99',
    },
    populararticleitem4: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontWeight: '400',
      fontSize: { base: '14px' },
      lineHeight: { base: 'auto' },
      color: '#FFFFFF',
      letterSpacing: '-1px',
      padding: '7px 12px 4px 18px',
    },
    populararticleitem5: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontWeight: '500',
      fontSize: { base: '12px' },
      lineHeight: { base: '140%' },
      color: '#FFFFFF',
    },
    sliderIcon: {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: '10',
      p: '10px',
    },
    tabtext: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { base: '16px' },
    },
  };

  const finalObj = merge(styleObj, { ...props });
  return finalObj;
};

const RescPrac = {
  en: commonLangStyle(
    { lang: 'en' },
    {
      heading: {
        fontFamily: 'FedraSansStd-book',
        fontSize: 60,
        lineHeight: '60px',
      },
    }
  ),
  bn: commonLangStyle(
    { lang: 'bn' },
    {
      title: {
        fontFamily: 'Anek-bangla',
      },
    }
  ),
  hi: commonLangStyle({
    lang: 'hi',
  }),
  te: commonLangStyle({ 
    lang: 'te',
    searchbuttonlink: {
      fontSize: { base: '12px', md: '12px' },
    },
  }),
  kn: commonLangStyle({ lang: 'kn' }),
  gu: commonLangStyle({ lang: 'gu' }),
  mr: commonLangStyle({ lang: 'mr' }),
  ml: commonLangStyle({ lang: 'ml' }),
  'zh-tw': commonLangStyle({ lang: 'zh-tw' }),
  zh: commonLangStyle({ lang: 'zh' }),
  it: commonLangStyle({ lang: 'it' }),
  fr: commonLangStyle({ lang: 'fr' }),
  de: commonLangStyle({ lang: 'de' }),
  es: commonLangStyle({ lang: 'es' }),
  ru: commonLangStyle({ 
    lang: 'ru',
  }),
  ta: commonLangStyle({
    lang: 'ta',
    title: {
      fontSize: { base: '24px', md: '30px' },
    },
    titleSubtext: {
      fontSize: { base: '40px', md: '42px' },
    },
    text3: {
      fontSize: { base: '2rem', md: '2rem' },
    },
    searchbuttonlink: {
      fontSize: { base: '12px' },
      padding: { base: '7px', md:'7px' },
      letterSpacing: '-3px',
    },
    tabtext: {
      fontSize: { base: '13px' },
    },
    populararticleitem4: {
      fontSize: { base: '12px' },
      padding: '7px 12px 4px 14px',
      letterSpacing: '-3px',
    },
    item5: {
      fontSize: { base: '13px' },
    },
  }),
  cn: commonLangStyle({ lang: 'cn' }),
  ar: commonLangStyle({
    lang: 'ar',
  }),
  id: commonLangStyle({ lang: 'id' }),
};
export default RescPrac;
